import { render } from "./StockList.vue?vue&type=template&id=543896de&scoped=true"
import script from "./StockList.vue?vue&type=script&lang=js"
export * from "./StockList.vue?vue&type=script&lang=js"

import "./StockList.vue?vue&type=style&index=0&id=543896de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543896de"]])

export default __exports__